export default __webpack_public_path__ + "static/media/logo.94d8b913.png";